var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tree',{ref:"tree",staticClass:"AProductTypeTreeSelector",attrs:{"default-expand-all":"","data":_vm.data,"props":_vm.props,"indent":10},on:{"current-change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }